import { modifyState } from '~src/state';
import {
  showSidebarTab,
  hideAllSidebarTabs,
  handleTabImages,
} from '~src/sidebarLegacy';
import editorConfig from '~config/editorConfig';

// Capture essential properties of the source image so we can
// recreate its transform onto the new MagicFrame object
const snapshotImageProps = (image) => {
  if (!image) return null;
  const obj = image.toObject ? image.toObject() : {};
  const src =
    (typeof image.getSrc === 'function' && image.getSrc()) ||
    image._element?.currentSrc ||
    image._element?.src ||
    obj?.src ||
    '';

  const giotto =
    image.get && image.get('giotto') ? image.get('giotto') : obj.giotto;

  return {
    objRefId: giotto?.objRefId,
    src,
    left: image.left,
    top: image.top,
    originX: image.originX || 'center',
    originY: image.originY || 'center',
    angle: image.angle || 0,
    width: image.width,
    height: image.height,
    scaleX: image.scaleX || 1,
    scaleY: image.scaleY || 1,
    flipX: image.flipX || false,
    flipY: image.flipY || false,
    opacity: typeof image.opacity === 'number' ? image.opacity : 1,
    skewX: image.skewX || 0,
    skewY: image.skewY || 0,
    shadow: image.shadow || obj.shadow || null,
    globalCompositeOperation:
      image.globalCompositeOperation || obj.globalCompositeOperation || null,
    // serialized filters so MagicFrame can rehydrate them
    filters: (obj && obj.filters) || [],
  };
};

export const prepareAddMagicFrameFromImage = async (image) => {
  // Save intent + source image so the sidebar click handler can complete the flow
  const snapshot = snapshotImageProps(image);
  if (!snapshot) return;

  await modifyState('magicFrameAddFromImageActive', true);
  await modifyState('magicFrameAddFromImageSource', snapshot);
  await modifyState('sidebarCurrentImagesTag', editorConfig.magicFrameTag);

  // Open Images tab focused on the Magic Frame tag, like "Sostituisci Cornice"
  hideAllSidebarTabs();
  showSidebarTab('immagini');
  await handleTabImages();

  try {
    const tag = window.editorConfig.sidebarTags.items.find(
      (t) => t.name === editorConfig.magicFrameTag
    );
    if (tag && window.$) {
      window
        .$?.('#select-ricerca-immagini')
        .val(tag.objectId)
        .trigger('change');
    }
  } catch (e) {
    // no-op: selector might not exist yet
  }
};
